import styled from 'styled-components';

import { DatePicker } from '@nhl/nhl-breakaway-ui';

export const DateSelect = styled(DatePicker)`
    height: 44px;
    width: 100%;
    z-index: 2;

    .react-date-picker-console {
        width: 100%;
    }
`;
